import React, { useEffect, useState } from "react";
import categoryAPI from "../../api/categoryApi";
import productAPI from "../../api/productApi";
import { useParams } from "react-router-dom";
import Breadcrump from "../../components/Breadcrump";
import SEO from "../../components/SEO";
import CategoryCard from "../categories/Card";
import ProductCard from "../products/Card";
import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Navigation,
  Pagination,
} from "../homepage/Shared/CustomSwiper";

function DetailPage() {
  const { "*": slug } = useParams();
  const [item, setItem] = useState({});
  const [subcategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState({});

  // Fallback: fetch products directly by this category's own id.
  // This makes sure ANY level (parent / subcategory / sub-subcategory)
  // shows its own products, even if the category-detail API only
  // returns products for leaf categories.
  const fetchProductsByCategoryId = async (categoryId) => {
    try {
      const res = await productAPI.listing({ category: [categoryId] });

      if (res.code === 200) {
        return res.data?.products || [];
      }
    } catch (err) {
      console.error("Error loading category products:", err);
    }
    return [];
  };

  const fetchCategoryDetail = async () => {
    try {
      const res = await categoryAPI.details(slug);

      if (res.code === 200) {
        const result = res.data;

        setItem(result?.category);
        setSubCategories(result?.subcategories);
        setMetaData(result?.category?.meta);

        let categoryProducts = result?.products || [];

        // Agar category-detail API ne products nahi diye (jaise beech ki
        // subcategory ke case mein), toh us category ke apne id se
        // products alag se fetch karlo.
        if (
          (!categoryProducts || categoryProducts.length === 0) &&
          result?.category?._id
        ) {
          categoryProducts = await fetchProductsByCategoryId(
            result.category._id,
          );
        }

        setProducts(categoryProducts);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchCategoryDetail();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.name} />

      <SEO meta={metaData} />

{subcategories && subcategories.length > 0 && (
        <section className="subcategory-section py-5">
          <div className="container">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={1}
              spaceBetween={20}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              breakpoints={{
                0: { slidesPerView: 1.8 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
              }}
            >
              {subcategories.map((subcategory, index) => (
                <SwiperSlide key={index}>
                  <CategoryCard item={subcategory} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      )}

      {/* PRODUCTS SECTION */}
      {products && products.length > 0 ? (
        <div className="py-4 bg-white">
          <div className="container">
            <div className="flat-animate-tab flat-controltab-nav">
              <div className="text-start">
                <h4 className="section-title">Our Products</h4>
              </div>
              <div className="row g-3 mt-2">
                {products.map((product, index) => (
                  <div
                    className="col-lg-3 col-6 mb-2"
                    key={product._id || index}
                  >
                    <ProductCard item={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-5 bg-white">
          <div className="container">
            <div className="text-center">
              <p>No Product Found in {item?.name} category</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
    

export default DetailPage;